export default __webpack_public_path__ + "static/media/midi_white.a41775d3.svg";